export default __webpack_public_path__ + "c6987275722cacb70a16bd92b0dfd575.svg";